import { render } from "./PassBlockBanner.vue?vue&type=template&id=6cefcd46"
import script from "./PassBlockBanner.vue?vue&type=script&lang=js"
export * from "./PassBlockBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__